import invert from "lodash/invert";
import {LayoutType} from "./constants";
import {UseFullSizeImages} from "../../../config";
import {pnpoly} from "../../../misc/utils";

let layouts = {};
Object.keys(LayoutType).forEach(layoutName => {
  layouts[layoutName] = {
    Walls: {
      Ceiling: 1000,
      RightWall: 2000,
      LeftWall: 3000,
      PopoutWall: 6000,
      Backsplash: 4000,
      BacksplashRightWall: 4050,
      BacksplashLeftWall: 4100,
      RightWallBacksplash: 4150,
      LeftWallBacksplash: 4200,
      // FourInchBacksplash: 12000,
      // FullHeightBacksplash: 13000,
      // SixHeightBacksplash: 14000,
    },
    Floor: 5000,
    Globals: {
      GlobalShadow: 7000,
      Baseboard: 8000,
      CeilingLights: 9000,
      CeilingHighlights: 10000,
      Decor1: 25000,
      Decor2: 32000,
      Decor3: 36500, // center island decor
      Decor4: 41000,
    },
    Cabinet: {
      TopCabinetShadow: 15000,
      TopCabinetShadowPart2: 15005,
      BottomCabinetShadow: 15500,
      TopCabinet: 16000,
      TopCabinetModuleBox: 16050,
      CrownMolding: 17000,
      TopCabinet2: 19000,  //Crown Molding should be higher than Top cabinet (c) Nikita
      TopCabinetModuleBox2: 219050,  //Crown Molding should be higher than Top cabinet (c) Nikita
      CrownMolding2: 20000,
      BottomCabinet: 22000,
      BottomCabinetModuleBox: 22050,
      BottomCabinet2: 27000,
      BottomCabinetModuleBox2: 27050,
      TopHandle: 28000,
      TopHandle2: 28100,
      BottomHandle: 28500,
      BottomHandle2: 28750,
      Peninsula: 29250,
      TopCabinetModules: {},
      BottomCabinetModules: {},
    },
    Appliances: {
      Microwave: 21000,
      Hood: 18000,
      Dishwasher: 23000,
      Range: 26000,
      Fridge: 29000,
      FridgeShadow: 29050,
    },
    CountertopGroup: {
      Countertop: 24000,
      Countertop2: 30000,
      Sink: 43000,
      Faucet: 44000,
      Stovetop: 45000,
      // Countertop3: 42000,
    },
    CenterIsland: {
      CenterIslandShadow: 29500,
      Cabinet: 31000,
      Countertop: 36000,
      Sink: 37000,
      Faucet: 38000,
      Stovetop: 38500,
      Range: 38750,
      ChairsShadow: 35000,
      Chairs: 39000,
      Handle: 40000,
    },
  };
});

layouts["Small"].Appliances.Fridge = 15750;
layouts["SmallWithPeninsula"].Appliances.Fridge = 15750;
layouts["SmallWithIsland"].Appliances.Fridge = 15750;
layouts["SmallWithPeninsulaWithIsland"].Appliances.Fridge = 15750;
layouts["Small"].Appliances.FridgeShadow = 15800;
layouts["SmallWithPeninsula"].Appliances.FridgeShadow = 15800;
layouts["SmallWithIsland"].Appliances.FridgeShadow = 15800;
layouts["SmallWithPeninsulaWithIsland"].Appliances.FridgeShadow = 15800;

let startTopCabinetZIndex = 17100;
let startTopCabinetZIndex2 = 21100;

let startBottomCabinetZIndex = 22100;
let startBottomCabinetZIndex2 = 27100;

Object.keys(LayoutType).forEach(layoutName => {
  let moduleTopNumber = 1, moduleBottomNumber = 1;
  for (let i = 1; i <= 8; i++) {  // 8 modules
    for (let k = 1; k <= 64; k++) {  // 64 module parts
      const module_modulePart = i + "_" + k;
      layouts[layoutName].Cabinet.TopCabinetModules[module_modulePart] = (i <= 5)
        ? startTopCabinetZIndex + (i*100)+ k
        : startTopCabinetZIndex2 + (moduleTopNumber*100)+ k;
      layouts[layoutName].Cabinet.BottomCabinetModules[module_modulePart] = (i <= 6)
        ? startBottomCabinetZIndex + (i*100)+ k
        : startBottomCabinetZIndex2 + (moduleBottomNumber*100)+ k;
    }
    if (i > 5) {
      moduleTopNumber++;
    }
    if (i > 6) {
      moduleBottomNumber++;
    }
  }
});

const getLayerDimensions = (zIndex, currentLayout) => {
  const fullImagesFactor = UseFullSizeImages ? 185.1851851851852 : 100;

  if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["1_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["1_64"])) {
    return {
      polygonArray: [[0,(fullImagesFactor/100)*240],[(fullImagesFactor/100)*290,(fullImagesFactor/100)*240],[(fullImagesFactor/100)*290,(fullImagesFactor/100)*400],[0,(fullImagesFactor/100)*400]],
      width: (fullImagesFactor/100)*290,
      height: (fullImagesFactor/100)*160
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["2_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["2_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*260,(fullImagesFactor/100)*270],[(fullImagesFactor/100)*480,(fullImagesFactor/100)*270],[(fullImagesFactor/100)*480,(fullImagesFactor/100)*510],[(fullImagesFactor/100)*260,(fullImagesFactor/100)*510]],
      width: (fullImagesFactor/100)*220,
      height: (fullImagesFactor/100)*240
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["3_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["3_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*470,(fullImagesFactor/100)*300],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*300],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*510],[(fullImagesFactor/100)*470,(fullImagesFactor/100)*510]],
      width: (fullImagesFactor/100)*160,
      height: (fullImagesFactor/100)*210
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["4_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["4_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*620,(fullImagesFactor/100)*310],[(fullImagesFactor/100)*770,(fullImagesFactor/100)*310],[(fullImagesFactor/100)*770,(fullImagesFactor/100)*510],[(fullImagesFactor/100)*620,(fullImagesFactor/100)*510]],
      width: (fullImagesFactor/100)*150,
      height: (fullImagesFactor/100)*200
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["5_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["5_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*750,(fullImagesFactor/100)*280],[(fullImagesFactor/100)*930,(fullImagesFactor/100)*280],[(fullImagesFactor/100)*930,(fullImagesFactor/100)*510],[(fullImagesFactor/100)*750,(fullImagesFactor/100)*280]],
      width: (fullImagesFactor/100)*180,
      height: (fullImagesFactor/100)*230
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["6_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["6_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*910,(fullImagesFactor/100)*260],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*260],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*510],[(fullImagesFactor/100)*910,(fullImagesFactor/100)*510]],
      width: (fullImagesFactor/100)*220,
      height: (fullImagesFactor/100)*250
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["7_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["7_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*1120,(fullImagesFactor/100)*220],[(fullImagesFactor/100)*1400,(fullImagesFactor/100)*220],[(fullImagesFactor/100)*1400,(fullImagesFactor/100)*520],[(fullImagesFactor/100)*1120,(fullImagesFactor/100)*520]],
      width: (fullImagesFactor/100)*280,
      height: (fullImagesFactor/100)*300
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["8_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["8_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*1380,(fullImagesFactor/100)*190],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*190],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*520],[(fullImagesFactor/100)*1380,(fullImagesFactor/100)*520]],
      width: (fullImagesFactor/100)*240,
      height: (fullImagesFactor/100)*330
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["1_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["1_64"])) {
    return {
      polygonArray: [[0,(fullImagesFactor/100)*240],[(fullImagesFactor/100)*290,(fullImagesFactor/100)*240],[(fullImagesFactor/100)*290,(fullImagesFactor/100)*400],[0,(fullImagesFactor/100)*400]],
      width: (fullImagesFactor/100)*290,
      height: (fullImagesFactor/100)*160
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["2_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["2_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*280,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*480,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*480,(fullImagesFactor/100)*850],[(fullImagesFactor/100)*280,(fullImagesFactor/100)*850]],
      width: (fullImagesFactor/100)*200,
      height: (fullImagesFactor/100)*230
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["3_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["3_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*470,(fullImagesFactor/100)*610],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*610],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*800],[(fullImagesFactor/100)*470,(fullImagesFactor/100)*800]],
      width: (fullImagesFactor/100)*160,
      height: (fullImagesFactor/100)*190
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["4_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["4_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*630,(fullImagesFactor/100)*600],[(fullImagesFactor/100)*760,(fullImagesFactor/100)*600],[(fullImagesFactor/100)*760,(fullImagesFactor/100)*800],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*800]],
      width: (fullImagesFactor/100)*130,
      height: (fullImagesFactor/100)*200
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["5_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["5_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*750,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*920,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*920,(fullImagesFactor/100)*840],[(fullImagesFactor/100)*750,(fullImagesFactor/100)*840]],
      width: (fullImagesFactor/100)*170,
      height: (fullImagesFactor/100)*220
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["6_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["6_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*910,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*880],[(fullImagesFactor/100)*910,(fullImagesFactor/100)*880]],
      width: (fullImagesFactor/100)*220,
      height: (fullImagesFactor/100)*240
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["7_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["7_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*1110,(fullImagesFactor/100)*660],[(fullImagesFactor/100)*1390,(fullImagesFactor/100)*660],[(fullImagesFactor/100)*1390,(fullImagesFactor/100)*940],[(fullImagesFactor/100)*1110,(fullImagesFactor/100)*940]],
      width: (fullImagesFactor/100)*280,
      height: (fullImagesFactor/100)*280
    };
  } else if ((zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["8_1"])
    && (zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["8_64"])) {
    return {
      polygonArray: [[(fullImagesFactor/100)*1380,(fullImagesFactor/100)*690],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*690],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*990],[(fullImagesFactor/100)*1380,(fullImagesFactor/100)*990]],
      width: (fullImagesFactor/100)*240,
      height: (fullImagesFactor/100)*300
    };
  }

  switch (zIndex) {
    case layouts[currentLayout].Floor:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*750],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*750],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1080],[0,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*1620,
        height: (fullImagesFactor/100)*330
      };

    //*** Walls ***//
    case layouts[currentLayout].Walls.LeftWall:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*100],[(fullImagesFactor/100)*740,(fullImagesFactor/100)*100],[(fullImagesFactor/100)*740,(fullImagesFactor/100)*900],[0,(fullImagesFactor/100)*900]],
        width: (fullImagesFactor/100)*740,
        height: (fullImagesFactor/100)*800
      };
    case layouts[currentLayout].Walls.LeftWallBacksplash:
      return {
        polygonArray: [[(fullImagesFactor/100)*210,(fullImagesFactor/100)*500],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*500],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*590],[(fullImagesFactor/100)*210,(fullImagesFactor/100)*590]],
      };
    case layouts[currentLayout].Walls.RightWall:
      return {
        polygonArray: [[(fullImagesFactor/100)*600,(fullImagesFactor/100)*45],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*45],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*970],[(fullImagesFactor/100)*600,(fullImagesFactor/100)*970]],
        width: (fullImagesFactor/100)*1020,
        height: (fullImagesFactor/100)*925
      };
    case layouts[currentLayout].Walls.RightWallBacksplash:
      return {
        polygonArray: [[(fullImagesFactor/100)*630,(fullImagesFactor/100)*330],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*200],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*580],[(fullImagesFactor/100)*630,(fullImagesFactor/100)*580]],
      };
    case layouts[currentLayout].Walls.Ceiling:
      return {
        polygonArray: [[0,0],[(fullImagesFactor/100)*1620,0],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*260],[0,(fullImagesFactor/100)*260]],
        width: (fullImagesFactor/100)*1620,
        height: (fullImagesFactor/100)*260
      };
    case layouts[currentLayout].Walls.PopoutWall:
      return {
        polygonArray: [[(fullImagesFactor/100)*200,(fullImagesFactor/100)*120],[(fullImagesFactor/100)*740,(fullImagesFactor/100)*120],[(fullImagesFactor/100)*740,(fullImagesFactor/100)*880],[(fullImagesFactor/100)*200,(fullImagesFactor/100)*880]],
        width: (fullImagesFactor/100)*540,
        height: (fullImagesFactor/100)*760
      };
    case layouts[currentLayout].Walls.Backsplash:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*200],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*200],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*700],[0,(fullImagesFactor/100)*700]],
        width: (fullImagesFactor/100)*1620,
        height: (fullImagesFactor/100)*500
      };
    case layouts[currentLayout].Walls.BacksplashLeftWall:
      return {
        polygonArray: [
          [(fullImagesFactor/100)*200,(fullImagesFactor/100)*280],
          [(fullImagesFactor/100)*632,(fullImagesFactor/100)*336],
          [(fullImagesFactor/100)*632,(fullImagesFactor/100)*600],
          [(fullImagesFactor/100)*200,(fullImagesFactor/100)*640]],
      };
    case layouts[currentLayout].Walls.BacksplashRightWall:
      return {
        polygonArray: [[(fullImagesFactor/100)*633,(fullImagesFactor/100)*336],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*210],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*680],[(fullImagesFactor/100)*633,(fullImagesFactor/100)*600]],
      };

    //*** Cabinet ***//
    case layouts[currentLayout].Cabinet.BottomCabinet:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*590],[(fullImagesFactor/100)*1000,(fullImagesFactor/100)*590],[(fullImagesFactor/100)*1000,(fullImagesFactor/100)*860],[0,(fullImagesFactor/100)*860]],
        width: (fullImagesFactor/100)*1000,
        height: (fullImagesFactor/100)*270
      };
    case layouts[currentLayout].Cabinet.BottomCabinet2:
      return {
        polygonArray: [[(fullImagesFactor/100)*1090,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1080],[(fullImagesFactor/100)*1090,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*530,
        height: (fullImagesFactor/100)*480
      };
    case layouts[currentLayout].Cabinet.CrownMolding:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*160],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*160],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*350],[0,(fullImagesFactor/100)*350]],
        width: (fullImagesFactor/100)*1620,
        height: (fullImagesFactor/100)*190
      };
    case layouts[currentLayout].Cabinet.CrownMolding2:
      return {
        polygonArray: [
          [(fullImagesFactor/100)*900,(fullImagesFactor/100)*110],
          [(fullImagesFactor/100)*1620,(fullImagesFactor/100)*110],
          [(fullImagesFactor/100)*1620,(fullImagesFactor/100)*280],
          [(fullImagesFactor/100)*900,(fullImagesFactor/100)*280]
        ],
        width: (fullImagesFactor/100)*720,
        height: (fullImagesFactor/100)*170
      };
    case layouts[currentLayout].Cabinet.TopCabinet:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*180],[(fullImagesFactor/100)*1000,(fullImagesFactor/100)*180],[(fullImagesFactor/100)*1000,(fullImagesFactor/100)*520],[0,(fullImagesFactor/100)*520]],
        width: (fullImagesFactor/100)*1000,
        height: (fullImagesFactor/100)*340
      };
    case layouts[currentLayout].Cabinet.TopCabinet2:
      return {
        polygonArray: [[(fullImagesFactor/100)*910,(fullImagesFactor/100)*130],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*130],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*530],[(fullImagesFactor/100)*910,(fullImagesFactor/100)*530]],
        width: (fullImagesFactor/100)*710,
        height: (fullImagesFactor/100)*400
      };
    case layouts[currentLayout].Cabinet.Peninsula:
      return {
        polygonArray: [[(fullImagesFactor/100)*1190,(fullImagesFactor/100)*650],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*650],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1080],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*430,
        height: (fullImagesFactor/100)*430
      };
    case layouts[currentLayout].Cabinet.TopHandle:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*230],[(fullImagesFactor/100)*990,(fullImagesFactor/100)*230],[(fullImagesFactor/100)*990,(fullImagesFactor/100)*550],[0,(fullImagesFactor/100)*550]],
        width: (fullImagesFactor/100)*990,
        height: (fullImagesFactor/100)*320
      };
    case layouts[currentLayout].Cabinet.TopHandle2:
      return {
        polygonArray: [[(fullImagesFactor/100)*990,(fullImagesFactor/100)*150],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*150],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*550],[(fullImagesFactor/100)*990,(fullImagesFactor/100)*550]],
        width: (fullImagesFactor/100)*630,
        height: (fullImagesFactor/100)*400
      };
    case layouts[currentLayout].Cabinet.BottomHandle:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*910,(fullImagesFactor/100)*620],[(fullImagesFactor/100)*910,(fullImagesFactor/100)*920],[0,(fullImagesFactor/100)*920]],
        width: (fullImagesFactor/100)*910,
        height: (fullImagesFactor/100)*300
      };
    case layouts[currentLayout].Cabinet.BottomHandle2:
      return {
        polygonArray: [[(fullImagesFactor/100)*1100,(fullImagesFactor/100)*670],[(fullImagesFactor/100)*1100,(fullImagesFactor/100)*670],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1000],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*1000]],
        width: (fullImagesFactor/100)*520,
        height: (fullImagesFactor/100)*330
      };

    //*** Appliances ***//
    case layouts[currentLayout].Appliances.Dishwasher:
      return {
        polygonArray: [[(fullImagesFactor/100)*650,(fullImagesFactor/100)*610],[(fullImagesFactor/100)*840,(fullImagesFactor/100)*840],[(fullImagesFactor/100)*840,(fullImagesFactor/100)*840],[(fullImagesFactor/100)*650,(fullImagesFactor/100)*610]],
        width: (fullImagesFactor/100)*190,
        height: (fullImagesFactor/100)*230
      };
    case layouts[currentLayout].Appliances.Fridge:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*400],[(fullImagesFactor/100)*880,(fullImagesFactor/100)*400],[(fullImagesFactor/100)*880,(fullImagesFactor/100)*1080],[0,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*880,
        height: (fullImagesFactor/100)*680
      };
    case layouts[currentLayout].Appliances.Hood:
      return {
        polygonArray: [[(fullImagesFactor/100)*870,(fullImagesFactor/100)*130],[(fullImagesFactor/100)*1190,(fullImagesFactor/100)*130],[(fullImagesFactor/100)*1190,(fullImagesFactor/100)*520],[(fullImagesFactor/100)*870,(fullImagesFactor/100)*520]],
        width: (fullImagesFactor/100)*320,
        height: (fullImagesFactor/100)*390
      };
    case layouts[currentLayout].Appliances.Microwave:
      return {
        polygonArray: [[(fullImagesFactor/100)*890,(fullImagesFactor/100)*370],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*370],[(fullImagesFactor/100)*1130,(fullImagesFactor/100)*520],[(fullImagesFactor/100)*890,(fullImagesFactor/100)*520]],
        width: (fullImagesFactor/100)*240,
        height: (fullImagesFactor/100)*150
      };
    case layouts[currentLayout].Appliances.Range:
      return {
        polygonArray: [[(fullImagesFactor/100)*890,(fullImagesFactor/100)*550],[(fullImagesFactor/100)*1200,(fullImagesFactor/100)*550],[(fullImagesFactor/100)*1200,(fullImagesFactor/100)*910],[(fullImagesFactor/100)*890,(fullImagesFactor/100)*910]],
        width: (fullImagesFactor/100)*310,
        height: (fullImagesFactor/100)*360
      };

    //*** CountertopGroup ***//
    case layouts[currentLayout].CountertopGroup.Countertop:
      return {
        polygonArray: [[0,(fullImagesFactor/100)*570],[(fullImagesFactor/100)*1020,(fullImagesFactor/100)*570],[(fullImagesFactor/100)*1020,(fullImagesFactor/100)*650],[0,(fullImagesFactor/100)*650]],
        width: (fullImagesFactor/100)*1020,
        height: (fullImagesFactor/100)*80
      };
    case layouts[currentLayout].CountertopGroup.Countertop2:
      return {
        polygonArray: [[(fullImagesFactor/100)*1090,(fullImagesFactor/100)*630],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*630],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*1070],[(fullImagesFactor/100)*1090,(fullImagesFactor/100)*1070]],
        width: (fullImagesFactor/100)*530,
        height: (fullImagesFactor/100)*440
      };
    case layouts[currentLayout].CountertopGroup.Sink:
      return {
        polygonArray: [[(fullImagesFactor/100)*1240,(fullImagesFactor/100)*630],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*630],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*720],[(fullImagesFactor/100)*1240,(fullImagesFactor/100)*720]],
        width: (fullImagesFactor/100)*380,
        height: (fullImagesFactor/100)*90
      };
    case layouts[currentLayout].CountertopGroup.Faucet:
      return {
        polygonArray: [[(fullImagesFactor/100)*1240,(fullImagesFactor/100)*580],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*580],[(fullImagesFactor/100)*1620,(fullImagesFactor/100)*720],[(fullImagesFactor/100)*1240,(fullImagesFactor/100)*720]],
        width: (fullImagesFactor/100)*380,
        height: (fullImagesFactor/100)*140
      };
    case layouts[currentLayout].CountertopGroup.Stovetop:
      return {
        polygonArray: [[(fullImagesFactor/100)*530,(fullImagesFactor/100)*660],[(fullImagesFactor/100)*920,(fullImagesFactor/100)*660],[(fullImagesFactor/920)*1200,(fullImagesFactor/100)*760],[(fullImagesFactor/100)*530,(fullImagesFactor/100)*760]],
        width: (fullImagesFactor/100)*390,
        height: (fullImagesFactor/100)*100
      };

    //*** CenterIsland ***//
    case layouts[currentLayout].CenterIsland.Cabinet:
    case layouts[currentLayout].CenterIsland.Handle:
      return {
        polygonArray: [[(fullImagesFactor/100)*250,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*1080],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*910,
        height: (fullImagesFactor/100)*440
      };
    case layouts[currentLayout].CenterIsland.Countertop:
      return {
        polygonArray: [[(fullImagesFactor/100)*110,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1190,(fullImagesFactor/100)*640],[(fullImagesFactor/100)*1190,(fullImagesFactor/100)*1080],[(fullImagesFactor/100)*110,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*1080,
        height: (fullImagesFactor/100)*(fullImagesFactor/100)*440
      };
    case layouts[currentLayout].CenterIsland.Chairs:
      return {
        polygonArray: [[(fullImagesFactor/100)*90,(fullImagesFactor/100)*690],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*690],[(fullImagesFactor/100)*1160,(fullImagesFactor/100)*1080],[(fullImagesFactor/100)*90,(fullImagesFactor/100)*1080]],
        width: (fullImagesFactor/100)*1070,
        height: (fullImagesFactor/100)*390
      };
    case layouts[currentLayout].CenterIsland.Sink:
      return {
        polygonArray: [[(fullImagesFactor/100)*530,(fullImagesFactor/100)*650],[(fullImagesFactor/100)*900,(fullImagesFactor/100)*650],[(fullImagesFactor/100)*900,(fullImagesFactor/100)*750],[(fullImagesFactor/100)*530,(fullImagesFactor/100)*750]],
        width: (fullImagesFactor/100)*370,
        height: (fullImagesFactor/100)*100
      };
    case layouts[currentLayout].CenterIsland.Faucet:
      return {
        polygonArray: [[(fullImagesFactor/100)*530,(fullImagesFactor/100)*550],[(fullImagesFactor/100)*900,(fullImagesFactor/100)*550],[(fullImagesFactor/100)*900,(fullImagesFactor/100)*750],[(fullImagesFactor/100)*530,(fullImagesFactor/100)*750]],
        width: (fullImagesFactor/100)*370,
        height: (fullImagesFactor/100)*200
      };
    case layouts[currentLayout].CenterIsland.Stovetop:
      return {
        polygonArray: [[(fullImagesFactor/100)*530,(fullImagesFactor/100)*660],[(fullImagesFactor/100)*920,(fullImagesFactor/100)*660],[(fullImagesFactor/920)*1200,(fullImagesFactor/100)*760],[(fullImagesFactor/100)*530,(fullImagesFactor/100)*760]],
        width: (fullImagesFactor/100)*390,
        height: (fullImagesFactor/100)*100
      };
    case layouts[currentLayout].CenterIsland.Range:
      return {
        polygonArray: [[(fullImagesFactor/100)*530,(fullImagesFactor/100)*660],[(fullImagesFactor/100)*920,(fullImagesFactor/100)*660],[(fullImagesFactor/920)*1200,(fullImagesFactor/100)*760],[(fullImagesFactor/100)*530,(fullImagesFactor/100)*760]],
        width: (fullImagesFactor/100)*390,
        height: (fullImagesFactor/100)*100
      };
    default:
      return null
  }
};
const checkForCanvasScale = (canvas, polygonArray) => {
  if (canvas && ((canvas.width !== canvas.offsetWidth) || (canvas.height !== canvas.offsetHeight))) {
    return polygonArray.map(point => {
      point = point.map(dot => Math.round(dot*canvas.offsetWidth/canvas.width));
      return point
    })
  }
  return polygonArray
};

export default {
  layouts,
  getMenuByHoveredLayer: (currentLayout, layer, canvas) => {
    // console.log('currentLayout', currentLayout);
    // console.log('layer', layer);
    if ((
      (layer.zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["1_1"])
      && (layer.zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["5_64"])
    ) || (
      (layer.zIndex >= layouts[currentLayout].Cabinet.TopCabinetModules["6_1"])
      && (layer.zIndex <= layouts[currentLayout].Cabinet.TopCabinetModules["8_64"])
    )) {
      return {
        contextMenuPartId: "top_cabinet",
        module: invert(layouts[currentLayout].Cabinet.TopCabinetModules)[layer.zIndex],
      };
    } else if ((
      (layer.zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["1_1"])
      && (layer.zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["6_64"])
    ) || (
      (layer.zIndex >= layouts[currentLayout].Cabinet.BottomCabinetModules["7_1"])
      && (layer.zIndex <= layouts[currentLayout].Cabinet.BottomCabinetModules["8_64"])
    )) {
      return {
        contextMenuPartId: "bottom_cabinet",
        module: invert(layouts[currentLayout].Cabinet.BottomCabinetModules)[layer.zIndex],
      };
    }
    switch (layer.zIndex) {
      case layouts[currentLayout].Floor:
        return {
          parent: "Floor",
          child: "Floor"
        };
      case layouts[currentLayout].Walls.LeftWall: {
        let leftWallBacksplash = getLayerDimensions(layouts[currentLayout].Walls.LeftWallBacksplash, currentLayout);
        leftWallBacksplash.polygonArray = checkForCanvasScale(canvas, leftWallBacksplash.polygonArray);
        if (pnpoly(leftWallBacksplash.polygonArray, document.hoveredMousePos)) {
          return {
            contextMenuPartId: "left_wall_custom"
          };
        } else {
          return {
            parent: "Walls",
            child: "Left Wall"
          };
        }
      }
      case layouts[currentLayout].Walls.RightWall: {
        let rightWallBacksplash = getLayerDimensions(layouts[currentLayout].Walls.RightWallBacksplash, currentLayout);
        rightWallBacksplash.polygonArray = checkForCanvasScale(canvas, rightWallBacksplash.polygonArray);
        if (pnpoly(rightWallBacksplash.polygonArray, document.hoveredMousePos)) {
          return {
            contextMenuPartId: "right_wall_custom"
          };
        } else {
          return {
            parent: "Walls",
            child: "Right Wall"
          };
        }
      }
      case layouts[currentLayout].Walls.PopoutWall:
        return {
          parent: "Walls",
          child: "Popout Wall"
        };
      case layouts[currentLayout].Walls.Backsplash: {
        let backsplashLeftWall = getLayerDimensions(layouts[currentLayout].Walls.BacksplashLeftWall, currentLayout);
        let backsplashRightWall = getLayerDimensions(layouts[currentLayout].Walls.BacksplashRightWall, currentLayout);
        backsplashLeftWall.polygonArray = checkForCanvasScale(canvas, backsplashLeftWall.polygonArray);
        backsplashRightWall.polygonArray = checkForCanvasScale(canvas, backsplashRightWall.polygonArray);
        if (pnpoly(backsplashLeftWall.polygonArray, document.hoveredMousePos)) {
          return {
            contextMenuPartId: "backsplash_custom_left"
          };
        } else if (pnpoly(backsplashRightWall.polygonArray, document.hoveredMousePos)) {
          return {
            contextMenuPartId: "backsplash_custom_right"
          };
        } else {
          return {
            contextMenuPartId: "backsplash_custom"
          };
        }
      }
      case layouts[currentLayout].Walls.Ceiling:
        return {
          parent: "Walls",
          child: "Ceiling"
        };
      case layouts[currentLayout].Cabinet.TopCabinet:
      case layouts[currentLayout].Cabinet.TopCabinet2:
        return {
          parent: "Cabinet",
          child: "Top Cabinet"
        };
      case layouts[currentLayout].Cabinet.BottomCabinet:
      case layouts[currentLayout].Cabinet.BottomCabinet2:
      case layouts[currentLayout].Cabinet.Peninsula:
        return {
          parent: "Cabinet",
          child: "Bottom Cabinet"
        };
      case layouts[currentLayout].Cabinet.CrownMolding:
      case layouts[currentLayout].Cabinet.CrownMolding2:
        return {
          parent: "Cabinet",
          child: "Crown Molding"
        };
      case layouts[currentLayout].Cabinet.TopHandle:
      case layouts[currentLayout].Cabinet.TopHandle2:
        return {
          parent: "Cabinet",
          child: "Top Handle"
        };
      case layouts[currentLayout].Cabinet.BottomHandle:
      case layouts[currentLayout].Cabinet.BottomHandle2:
        return {
          parent: "Cabinet",
          child: "Bottom Handle"
        };
      case layouts[currentLayout].Appliances.Range:
        return {
          parent: "Appliance",
          child: "Range"
        };
      case layouts[currentLayout].Appliances.Fridge:
        return {
          parent: "Appliance",
          child: "Fridge"
        };
      case layouts[currentLayout].Appliances.Hood:
        return {
          parent: "Appliance",
          child: "Hood"
        };
      case layouts[currentLayout].Appliances.Microwave:
        return {
          parent: "Appliance",
          child: "Microwave"
        };
      case layouts[currentLayout].Appliances.Dishwasher:
        return {
          parent: "Appliance",
          child: "Dishwasher"
        };
      case layouts[currentLayout].CountertopGroup.Edge:
        return {
          parent: "Countertop",
          child: "Edge"
        };
      // case layouts[currentLayout].CountertopGroup.Countertop2:
      case layouts[currentLayout].CountertopGroup.Sink:
      case layouts[currentLayout].CountertopGroup.Faucet:
      case layouts[currentLayout].CountertopGroup.Countertop:
      case layouts[currentLayout].CountertopGroup.Countertop2:
        return {
          contextMenuPartId: "countertop_group_custom"
        };
      case layouts[currentLayout].CountertopGroup.Stovetop:
        return {
          parent: "Countertop",
          child: "Stovetop"
        };
      case layouts[currentLayout].CenterIsland.Chairs:
        return {
          parent: "Center Island",
          child: "Chairs"
        };
      case layouts[currentLayout].CenterIsland.Cabinet:
        return {
          parent: "Center Island",
          child: "Cabinet"
        };
      case layouts[currentLayout].CenterIsland.Edge:
        return {
          parent: "Center Island",
          child: "Edge"
        };
      case layouts[currentLayout].CenterIsland.Faucet:
      case layouts[currentLayout].CenterIsland.Sink:
      case layouts[currentLayout].CenterIsland.Stovetop:
      case layouts[currentLayout].CenterIsland.Range:
      case layouts[currentLayout].CenterIsland.Countertop:
        return {
          contextMenuPartId: "center_island_custom"
        };
      case layouts[currentLayout].CenterIsland.Handle:
        return {
          parent: "Center Island",
          child: "Handle"
        };
      default:
        return ""
    }
  },
  getLayerDimensions
}


